import styled from 'styled-components';
import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
export const GrayBackground = styled.div `
  background-color: ${COLORS.lightestGray};
`;
